export default __webpack_public_path__ + "static/media/ng4.7076d793.jpg";